"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.medicineSync = void 0;
const store_1 = require("client/modules/inventory/modules/inventory-detail/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const mobx_1 = require("mobx");
const currentMeds = require("../../../../../../../data/sheets/currentMeds.json");
/**
 * Imports currentMeds.json to populate the completed inventory with portal
 * data (dx codes, sig, refills).
 *
 * @returns A Promise.All() of process-pending medicine data updates.
 */
exports.medicineSync = () => {
    const rows = currentMeds;
    const existingInventory = [];
    const getInventory = store_2.inventoryListStore
        .loadInventory()
        .then(() => Object.values(mobx_1.toJS(store_2.inventoryListStore.inventory.value)).forEach((item) => item.children.forEach((med) => existingInventory.push(med))));
    /**
     * Return a promise of inventory items to conditionally be created and
     * linked.
     *
     * @returns A promise awaiting site-to-inventory connection.
     */
    return getInventory.then(() => existingInventory.forEach(async (medication) => {
        const pkg = medication.package;
        const medData = rows[pkg];
        const sigs = medData.sig.split(";") || "";
        const dxCodes = medData.dx.replace(" ", "").split(",");
        // const qty = medData.quantity;
        // const duration = medData.duration;  //#TK commented b/c never read
        const qtyToRun = medData.qtyToRun;
        medication.defaultSig = sigs[0] || "";
        medication.defaultSig2 = sigs[1] || "";
        medication.defaultSig3 = sigs[2] || "";
        if (qtyToRun === '1')
            medication.claimQuantity = '1';
        medication.inventoryCodes = [];
        for (const dx of dxCodes) {
            await store_1.inventoryDetailStore.findICD10(dx).then((x) => {
                const icd = x[0]["dispensify-icd10"];
                const icdCode = {
                    id: icd.id,
                    label: icd.shortDesc,
                    value: icd.icd10,
                    tokenLabel: icd.icd10,
                };
                medication.inventoryCodes.push(icdCode);
            });
        }
        return store_1.inventoryDetailStore.saveInventory(medication);
    }));
};
/*
    inventoryId: number;
    CodeType: string;
    Code: string;
    CodeDescription: string; */



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/modules/google-medicine.ts
// module id = 4136
// module chunks = 0